module.exports = __webpack_public_path__ + "img/partners-list.4744dac8.png";